import { Card, Grid, SxProps, Theme, Typography, Tooltip, Box } from "@mui/material";
import React from "react";

type Props = {
  title: string;
  subtitle?: string;
  children: React.ReactNode;
  sx?: SxProps<Theme>;
  tooltip?: string;
};

const HorizontalCard: React.FC<Props> = ({
  title,
  subtitle,
  tooltip,
  children,
  sx,
}) => {
  return (
    <Card variant="outlined" sx={{ minHeight: { xs: 0, sm: 200 }, p: 2, ...sx }}>
      <Grid container rowSpacing={2}>
        <Grid item xs={12} sm={4}>
          <Tooltip title={tooltip ?? ''} placement='right-start'>
            <Box>
              <Typography variant="h6">{title}</Typography>
              <Typography>{subtitle}</Typography>
            </Box>
          </Tooltip>
        </Grid>
        <Grid item container spacing={2} direction="column" xs={12} sm={8}>
          {children}
        </Grid>
      </Grid>
    </Card>
  );
};

export default HorizontalCard;
